import { render } from "./RozetkaCredentialFields.vue?vue&type=template&id=873799fe"
import script from "./RozetkaCredentialFields.vue?vue&type=script&lang=js"
export * from "./RozetkaCredentialFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__